var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-products-popup"},[_c('div',{staticClass:"message"},[_c('p',[_vm._v("No products found.")])])])
}]

export { render, staticRenderFns }